import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy hosted-UI sign-in form. It called loginRedirect() with NO
// identity_provider, which lands on the raw Cognito hosted login+signup page —
// exactly what N.E.S.T. must never expose. The terminal login (/sign-in) is the
// only sanctioned entry point, so this route now redirects there. (#449)
export const Route = createFileRoute('/(auth)/sign-in-2')({
  beforeLoad: () => {
    throw redirect({ to: '/sign-in' })
  },
})
